import React, { Fragment, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router';
import { Breadcrumbs, H5 } from '../../AbstractElements';
import { Card, CardBody, CardHeader, Col, Row, Table } from 'reactstrap';
import { ArrowLeft } from 'react-feather';
import { useLoader } from '../../_helper/LoaderContext';
import { usePharmacy } from '../../_helper/PharmacyProvider';
import { getItemDetails } from '../PharmacyMedicineAdd/PharmacyMedicineService';

const ViewOTC = () => {
	const { mdcId } = useParams();
	const { t } = useTranslation();
	const history = useNavigate();
	const { setLoading } = useLoader();
		const { pharmacyPOS } = usePharmacy();
	const [medicineDetails, setMedicineDetails] = useState(null);

	// ✅ Fetch item details on load
	useEffect(() => {
		const fetchItem = async () => {
			try {
				setLoading(true);
				const body = {
					itemId: mdcId,
					clinicId: pharmacyPOS?.hospital_id,
				}

				const res = await getItemDetails(body);

				// ✅ Access the nested item
				if (res?.data?.data) {
					const item = res.data.data;
					setMedicineDetails(item);
				}
			} catch (error) {
				console.error("Error fetching item:", error);
			} finally {
				setLoading(false);
			}
		};

		fetchItem();
	}, [mdcId]);

	const gotoList = () => {
		history(`${process.env.PUBLIC_URL}/items`);
	}

	// ✅ Simple field renderer
	const renderField = (label, value) => (
		<div className="mb-3">
			<strong>{t(label)}: </strong> {value || "-"}
		</div>
	);

	return (
		<Fragment>
			<Breadcrumbs mainTitle={t('OTC Item Details')} parent={t('Dashboard')} title={t('OTC Item Details')} />
			<Col sm="12">
				<Card>
					<CardHeader className="d-flex justify-content-end align-items-center">
						{/* <H5>{t('Medicine Details')}</H5> */}
						<button
							className="btn btn-primary d-flex align-items-center"
							style={{ color: 'white', height: "40px" }}
							to=""
							onClick={gotoList}>
							<ArrowLeft className="me-2" /> {t("Back")}
						</button>
					</CardHeader>
					<CardBody>
						{/* {medicineDetails ? ( */}
						<div className="table-responsive rounded">
							<Table className="table-center table-bordered mb-0 table-hover">
								<tbody>
									<tr>
										<th><strong>{t("Code")}</strong></th>
										<td>{medicineDetails?.code}</td>
									</tr>
									<tr>
										<th><strong>{t("Product Name")}</strong></th>
										<td>{medicineDetails?.brandName}</td>
									</tr>
									<tr>
										<th><strong>{t("Manufacturer")}</strong></th>
										<td>{medicineDetails?.manufacturer}</td>
									</tr>
									<tr>
										<th><strong>{t("Product Form")}</strong></th>
										<td>{medicineDetails?.productForm}</td>
									</tr>
									<tr>
										<th><strong>{t("Package")}</strong></th>
										<td>{medicineDetails?.package}</td>
									</tr>
									<tr>
										<th><strong>{t("Quantity")}</strong></th>
										<td>{medicineDetails?.packageQuantity}</td>
									</tr>
									<tr>
										<th><strong>{t("MRP")}</strong></th>
										<td>{medicineDetails?.regularPrice} {medicineDetails?.currency}</td>
									</tr>
									<tr>
										<th><strong>{t("Min Quantity Alert")}</strong></th>
										<td>{medicineDetails?.minQuantityAlert}</td>
									</tr>
									
									<tr>
										<th><strong>{t("Note")}</strong></th>
										<td>{medicineDetails?.note !== "" ? medicineDetails?.note : "-"}</td>
									</tr>
								</tbody>
							</Table>
						</div>
					</CardBody>
				</Card>
			</Col>
		</Fragment>
	)
}

export default ViewOTC;